(function () {
  'use strict';
  var script = document.currentScript;
  var root = (script && script.dataset.root || '/').replace(/\/$/, '');
  if (!root || !root.startsWith('/')) return;

  // Only ordinary storefront destinations without a language/market prefix.
  // Deliberately localized links, account routes and external URLs stay intact.
  var storefrontPath = /^\/(?:collections|products|pages|blogs|search|cart)(?:\/|$)/;
  function localize(anchor) {
    if (!anchor || !anchor.getAttribute || anchor.hasAttribute('download') ||
        anchor.hasAttribute('data-localization-ignore')) return;
    var href = anchor.getAttribute('href');
    if (!href || href.charAt(0) === '#') return;
    var url;
    try { url = new URL(href, document.baseURI); } catch (_) { return; }
    if (url.origin !== location.origin) return;
    var path = url.pathname;
    var language = (document.documentElement.lang || '').toLowerCase().split('-')[0];
    var languageOnly = '/' + language;
    if (language && root.toLowerCase().startsWith(languageOnly + '-') &&
        path.toLowerCase().startsWith(languageOnly + '/')) {
      var withoutLanguage = path.slice(languageOnly.length);
      if (storefrontPath.test(withoutLanguage)) path = withoutLanguage;
    }
    if (!storefrontPath.test(path)) return;
    anchor.setAttribute('href', root + path + url.search + url.hash);
  }
  function scan(node) {
    if (!node || node.nodeType !== 1) return;
    if (node.matches('a[href]')) localize(node);
    node.querySelectorAll('a[href]').forEach(localize);
  }
  function handle(event) {
    var path = event.composedPath ? event.composedPath() : [event.target];
    for (var i = 0; i < path.length; i++) {
      if (path[i] && path[i].tagName === 'A') { localize(path[i]); break; }
    }
  }
  ['pointerdown', 'click', 'auxclick', 'contextmenu', 'focusin'].forEach(function (name) {
    document.addEventListener(name, handle, true);
  });
  function start() {
    scan(document.documentElement);
    new MutationObserver(function (changes) {
      changes.forEach(function (change) {
        if (change.type === 'attributes') localize(change.target);
        else change.addedNodes.forEach(scan);
      });
    }).observe(document.documentElement, {subtree: true, childList: true, attributes: true, attributeFilter: ['href']});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
